import { cn } from "@/utils/cn";
import { Sparkles } from "lucide-react";

interface SampleDataBadgeProps {
  className?: string;
  size?: "sm" | "md";
  variant?: "subtle" | "solid";
}

export function SampleDataBadge({ className, size = "sm", variant = "subtle" }: SampleDataBadgeProps) {
  const base = "inline-flex items-center gap-2 rounded-full select-none";
  const sizing = size === "md" ? "px-3 py-1.5 text-sm" : "px-2.5 py-1 text-xs";
  const subtle = cn(
    "bg-dark-800/60 border border-white/10 text-white/90",
    "backdrop-blur supports-[backdrop-filter]:backdrop-blur-sm",
    "shadow-[inset_0_1px_0_rgba(255,255,255,0.04),0_0_0_1px_rgba(120,119,198,0.20)]",
  );
  const solid = cn("bg-gradient-to-r from-brand-blue to-brand-purple text-white", "shadow-md border border-white/20");
  const styles = cn(base, sizing, variant === "solid" ? solid : subtle, className);
  return (
    <div className={styles} aria-label="Sample data active" title="Sample data active">
      <span className="w-1.5 h-1.5 rounded-full bg-brand-blue/90 shadow-[0_0_0_2px_rgba(59,130,246,0.22)]" />
      <span className="font-medium tracking-tight">Sample Data</span>
      <Sparkles
        className={cn(
          size === "md" ? "w-3.5 h-3.5" : "w-3 h-3",
          "text-brand-blue"
        )}
      />
    </div>
  );
}
